export default __webpack_public_path__ + "static/media/icon-singleCarryRight.5e48e2f3.svg";